export default __webpack_public_path__ + "static/media/keto_labels@3x.c725d494.jpg";